'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { css } from 'styled-components';
import { TABLETWIDTH, LAPTOPHEIGHT } from './constants';
export var LaptopAndAbove = function LaptopAndAbove() {
  return css(["@media only screen and (min-width:", "){", ";}"], TABLETWIDTH + 100, css.apply(void 0, arguments));
};
export var TabletAndBelow = function TabletAndBelow() {
  return css(["@media only screen and (max-width:", "){", ";}"], TABLETWIDTH, css.apply(void 0, arguments));
};
export var LaptopHeight = function LaptopHeight(content) {
  return css(["@media only screen and (max-height:", "){", ";}"], LAPTOPHEIGHT, css.apply(void 0, _toConsumableArray(content)));
};